import { __generator } from "tslib";
import axios from 'axios';
import { call, select } from 'redux-saga/effects';
import { ConfigSelectors } from '../config';
import ddt from '@wix/da-ddt';
var CANONICAL_XHR_ENDPOINT = 'https://www.deviantart.com/_napi/shared_api/';
function getFakeResponse(response) {
    return new Promise(function (resolve) {
        setTimeout(function () { return resolve(response); }, 1000);
    });
}
function getApiResponse(options) {
    return axios
        .request(options)
        .then(function (response) {
        return response.data;
    })
        .catch(function (response) {
        return false;
    });
}
export function request(options, fakeResponse) {
    var _a, _b, _c, withCreds, result, doFake;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!(options.baseURL === undefined)) return [3 /*break*/, 3];
                if (!(process.env.NODE_ENV !== 'production')) return [3 /*break*/, 2];
                _a = options;
                return [4 /*yield*/, select(ConfigSelectors.key('sharedApiBasePath'))];
            case 1:
                _a.baseURL = _d.sent();
                return [3 /*break*/, 3];
            case 2:
                options.baseURL = CANONICAL_XHR_ENDPOINT;
                _d.label = 3;
            case 3:
                if (!(options.method && options.method.toLowerCase() === 'post')) return [3 /*break*/, 5];
                _b = options.data;
                _c = 'csrf_token';
                return [4 /*yield*/, select(ConfigSelectors.key('csrfToken'))];
            case 4:
                _b[_c] = _d.sent();
                _d.label = 5;
            case 5: return [4 /*yield*/, select(ConfigSelectors.key('withCredentials'))];
            case 6:
                withCreds = _d.sent();
                if (withCreds) {
                    options.withCredentials = true;
                }
                if (!(process.env.NODE_ENV !== 'production')) return [3 /*break*/, 9];
                if (!(fakeResponse !== undefined)) return [3 /*break*/, 9];
                return [4 /*yield*/, select(ConfigSelectors.key('fakeApiRequests'))];
            case 7:
                doFake = _d.sent();
                if (!doFake) return [3 /*break*/, 9];
                ddt.log('saga', "Faked XHR for: " + options.url, options);
                return [4 /*yield*/, call(getFakeResponse, fakeResponse(options))];
            case 8:
                result = _d.sent();
                return [2 /*return*/, result];
            case 9: return [4 /*yield*/, call(getApiResponse, options)];
            case 10:
                result = _d.sent();
                return [2 /*return*/, result];
        }
    });
}
//# sourceMappingURL=request.js.map